import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/turquoise-tropical-beautiful-outdoors-tourism.jpg")